import { AfterViewChecked, ChangeDetectorRef, Component, OnInit, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import * as echarts from 'echarts';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { VariablePayLetterPopupComponent } from 'src/app/shared/popups/variable-pay-letter-popup/variable-pay-letter-popup.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { VariablePayDashboardPopupComponent } from 'src/app/shared/popups/variable-pay-dashboard-popup/variable-pay-dashboard-popup.component';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { debounceTime, forkJoin, Observable, of, Subject, Subscription, switchMap, tap } from 'rxjs';
import { DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import jsPDF from 'jspdf';
// import html2canvas from 'html2canvas';
import { calculateFiscalYear, createChart, formatYearRanges } from 'src/app/shared/commen-function-file';
import { formatDate } from 'src/app/shared/commen-function-file';
import { PdfDownloadService } from 'src/app/pdf-download-service.service';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatDateRangePicker } from '@angular/material/datepicker';
import { ExpenseDashboardDetailsComponent } from '../expense-dashboard-details/expense-dashboard-details.component';
export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD-MM-YYYY'
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}

@Component({
  selector: 'app-expense-dashboard',
  templateUrl: './expense-dashboard.component.html',
  styleUrls: ['./expense-dashboard.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // Use en-GB to get DD/MM/YYYY format
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})
export class ExpenseDashboardComponent implements OnInit, OnDestroy {

  buttonColorName: any;
  loggedInUserName: any;
  subModuleButtonColor: any;
  loggedInUserCompanyID: any;
  loggedInCompanyFiscalyear: any;
  loggedInUserId: any;
  loggedInUserRole: any;
  loggedInUserRoles: any;
  loggedInCompanyReviewCycle: any;
  isShowMD: any;
  genderWiseData: any = [];
  dropdownSettings: IDropdownSettings = {};
  taskFromDate: any;
  taskToDate: any; // Holds the filtered data
  reimbursementData: any[] = [];
  reimbursementTypeCount: any[] = [];
  reimbursementTypeTable: any[] = [];
  pmsYears: any = []
  selectedYearForReimbursement: any = null;
  selectedYearForDashboard: any;
  currentYearSelected: any;
  fromYear: any;
  toYear: any;
  selectedFromDated: any;
  selectedtoDated: any;
  selectGraphType: any = 'bar';
  selectGraphTwoType: any = 'bar';
  selectGraphThreeType: any = 'bar';
  totalExpenseRaisedCount: any = [];
  employPendingCount: any;
  totalExpenseApprovedByfinance: any;
  totalExpensePendingByfinance: any;
  userId: any;
  employeeCount: any;
  employeeApprovedCount: any;
  employeeRejectedCount: any;
  employeIDFromUserTable: any;
  raisedEmployeeUnderManager: any;
  approvedEmployeeUnderManager: any;
  rejectedEmployeeUnderManager: any;
  pendingEmployeeUnderManager: any;
  getEmployeeList: any = [];
  OnlyFinance: any;
  OnlyManager: any;
  selectUserId: any;
  passApprovematrixForReport: any;
  pendingWithManager: any;
  arrEmployeeDetiails: any = [];
  employeeID: any;
  forEmployeDDlogginUserID: any;
  currentPendingWithManager: any;
  selectFromDate: any = null;
  selectToDate: any = null;
  selectFromDateThird: any = null;
  selectToDateThird: any = null;
  constructor(public router: Router, private httpService: HttpService, private encryptionService: EncryptionService,
    private config: Config, private activatedroute: ActivatedRoute, public sharedService: SharedService, public dialog: MatDialog,
    private fb: FormBuilder, private datePipe: DatePipe, private cdRef: ChangeDetectorRef, private PdfDownload: PdfDownloadService
  ) {

  }
 
  ngOnInit() {


    this.httpService.employeIDUnderManager.subscribe((data: any) => {
      this.employeIDFromUserTable = data
    })
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }

    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;
    this.isShowMD = this.loggedInUserRoles.some((role: any) => role.name === 'MD');
    this.userId = this.loggedInUserId;
    this.loggdinUserIDBydefault = this.loggedInUserId;
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };

    this.getpmsyearlist();
    this.getEmployee();
    this.getEmployeeDetiails();
    this.employeeID = this.loggedInUserId
    setTimeout(() => {
      this.OnlyFinance = sessionStorage.getItem('financeAdminId') == this.loggedInUserId;

      this.passApprovematrixForReport = this.httpService.passApprovematrixForReport;

      this.dashBoardreimbursmentData();
    }, 100)

    this.forEmployeDDlogginUserID = parseInt(this.loggedInUserId);

    let today = new Date();
    // Set the taskFromDate to 15 days before today's date
    let taskFromDate = new Date(today);
    taskFromDate.setDate(today.getDate() - 12);
    this.taskFromDateForAllGraph =  taskFromDate.toISOString().split('T')[0];
 
    // Set the taskToDate to today's date
    let taskToDate  =  new Date(today);
     taskToDate.setDate(today.getDate() + 2);
    this.taskToDateForAllGraph =  taskToDate.toISOString().split('T')[0];


  }
  EmployeeSummaryData: any = []

  getEmployee() {

    const request = {
      "companyId": this.loggedInUserCompanyID,
      "userId": this.loggedInUserId
    };
    this.httpService.callPostService(this.config.getTeamOfManager, request).subscribe((data: any) => {
      this.EmployeeSummaryData = data.data;

    })
  }
  getEmployeeDetiails() {

    this.httpService.callGetService(`${this.config.EmployeeDetiailsBandLocation}/${this.loggedInUserCompanyID}`).subscribe((result: any) => {
      this.arrEmployeeDetiails = result.data;

    });

  }

  arrExpenseTypeRaised: any;
  loggdinUserIDBydefault: any;
  currentApprovedData: any
  currentPendingData: any

  dashBoardreimbursmentData() {
    this.httpService.reimbursementData$.subscribe((response: any) => {
console.error(response)
console.error(this.selectedYearForReimbursement)
      let data = response.filter((record: any) => record.year == this.selectedYearForReimbursement);
      let ApprovedBYFinace, pendingBYFinace;

      if (this.loggedInUserRole == 'Employee') {
        //-------------------------------------Employee----
        console.log("In  Employee Side");

        if (this.OnlyFinance) {
          // For Finance
          console.log("For Finance");

          ApprovedBYFinace = data.filter((record: any) => record.approvedStatus == 'APPROVED' && record.financeId == this.userId);
          pendingBYFinace = data.filter((record: any) => record.approvedStatus == 'PENDING');

          this.arrExpenseTypeRaised = data;
          // this.arrExpenseTypeRaised = data.filter((elm: any) => elm.employeeId == this.userId || elm.financeId == this.userId);


          // this.totalExpenseRaisedCount = data.filter((elm: any) => elm.employeeId == this.userId || elm.financeId == this.userId).length;
          this.totalExpenseRaisedCount = data.length;

          this.totalExpenseApprovedByfinance = ApprovedBYFinace.length;
          this.totalExpensePendingByfinance = pendingBYFinace.length;

        } else {
          // For Employee
          console.log("For Employee");

          this.employeeCount = data.filter((elm: any) => elm.employeeId == this.userId);
          this.employeeApprovedCount = this.employeeCount.filter((elm: any) => elm.approvedStatus == 'APPROVED');
          this.employeeRejectedCount = this.employeeCount.filter((elm: any) => elm.approvedStatus == 'REJECTED');

          if (this.httpService.passApprovematrixForReport == 'EMPLOYEE_TO_FINANCE') {
            this.employPendingCount = this.employeeCount.filter((elm: any) => (elm.approvedStatus == 'PENDING'));
          } else {
            this.employPendingCount = this.employeeCount.filter((elm: any) => (elm.approvedByManager == 'APPROVED' && elm.approvedStatus == 'PENDING'));

          }

          this.arrExpenseTypeRaised = this.employeeCount;

          this.totalExpenseRaisedCount = this.employeeCount.length;

          this.totalExpenseApprovedByfinance = this.employeeApprovedCount.length;
          this.totalExpensePendingByfinance = this.employPendingCount.length;

        }



      } else if (this.loggedInUserRole != 'Employee' && this.loggedInUserRole != 'Manager' && this.loggedInUserRole != 'HOD' && this.loggedInUserRole != 'MD') {
        console.log("In  HR Admin Side    " +this.loggedInUserRole);
        //---------------------------------------------------HR Loggin-----------
        ApprovedBYFinace = data.filter((record: any) => record.approvedStatus == 'APPROVED');
        pendingBYFinace = data.filter((record: any) => (record.approvedStatus == 'PENDING' && record.approvedByManager == 'APPROVED' ) );
        
        this.arrExpenseTypeRaised = data;
        this.totalExpenseRaisedCount = data.length;
        this.totalExpenseApprovedByfinance = ApprovedBYFinace.length;
        this.totalExpensePendingByfinance = pendingBYFinace.length;


      } else if ((this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'MD') && sessionStorage.getItem('financeAdminId') != this.loggedInUserId) {
        //------------------------------------------Manager-------------------------------------------------------------------------
        console.log("In  Manager Side");

        const loggdinguserId = this.loggedInUserId
        this.OnlyManager = (this.loggedInUserId != this.forEmployeDDlogginUserID) ? true : false;
        
        let managerEmployeId: string | any[];
        let ManagerEmployeeDorpDownData: any;
        setTimeout(() => {
          managerEmployeId = this.EmployeeSummaryData.map((elm: any) => elm.id);


          ManagerEmployeeDorpDownData = data.filter((record: any) => managerEmployeId?.includes(record.employeeId) || record.employeeId == loggdinguserId);

          let getEmployeeListFromApi = this.removeDuplicateEmployeeIds(ManagerEmployeeDorpDownData);


          const userLoginData = [{
            employeeName: this.loggedInUserName,
            employeeId: parseInt(this.loggedInUserId)

          }]
          const getEmployeeList = [...userLoginData, ...getEmployeeListFromApi] ;
          
          getEmployeeList.map((elm:any)=>{
            if (!this.getEmployeeList.some((record: any) => record.employeeId === elm.employeeId)){
              this.getEmployeeList.push(elm);
            }
          });
          
          this.employeeID = this.forEmployeDDlogginUserID 

        }, 200);


        this.raisedEmployeeUnderManager = data.filter((record: any) => record.employeeId == this.loggdinUserIDBydefault);
        console.error(data)
        this.approvedEmployeeUnderManager = this.raisedEmployeeUnderManager.filter((record: any) => record.approvedStatus == 'APPROVED');

        const pendingWithManager = this.raisedEmployeeUnderManager.filter((record: any) => record.approvedByManager == null && this.loggedInUserId != record.employeeId);
        this.pendingWithManager = pendingWithManager.length;
        this.currentPendingWithManager = pendingWithManager.length;

        this.rejectedEmployeeUnderManager = this.raisedEmployeeUnderManager.filter((record: any) => record.approvedStatus == 'REJECTED');
   
        
        this.pendingEmployeeUnderManager = this.raisedEmployeeUnderManager.filter((record: any) => (record.approvedByManager == 'APPROVED' && record.approvedStatus == 'PENDING'));

        this.arrExpenseTypeRaised = this.raisedEmployeeUnderManager;

        this.totalExpenseRaisedCount = this.raisedEmployeeUnderManager.length;
        this.totalExpenseApprovedByfinance = this.approvedEmployeeUnderManager.length;
        this.totalExpensePendingByfinance = this.pendingEmployeeUnderManager.length;

      } else {
        console.log("In  Fianace Side");


        let managerEmployeId = this.EmployeeSummaryData.map((elm: any) => elm.id);
        // let ManagerEmployeeDorpDownData = data.filter((record: any) => record.financeId == this.loggedInUserId);
        let ManagerEmployeeDorpDownData;
        if (this.httpService.passApprovematrixForReport == 'EMPLOYEE_TO_FINANCE') {
          ManagerEmployeeDorpDownData = data.filter((elm: any) => ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId))));
          pendingBYFinace = ManagerEmployeeDorpDownData.filter((record: any) => (record.approvedStatus == 'PENDING'));
        } else {

          ManagerEmployeeDorpDownData = data.filter((elm: any) => elm.approvedByManager === "APPROVED" && ((elm.financeId == null) || (elm.financeId == parseInt(this.loggedInUserId))))
          pendingBYFinace = ManagerEmployeeDorpDownData.filter((record: any) => (record.approvedByManager == 'APPROVED' && record.approvedStatus == 'PENDING'));
        }
        ApprovedBYFinace = ManagerEmployeeDorpDownData.filter((record: any) => record.approvedStatus == 'APPROVED' && record.financeId == this.loggedInUserId);



        this.arrExpenseTypeRaised = ManagerEmployeeDorpDownData;
        this.arrExpenseTypeRaised = data;

        // this.totalExpenseRaisedCount = ManagerEmployeeDorpDownData.length;
        this.totalExpenseRaisedCount = data.length;
        this.totalExpenseApprovedByfinance = ApprovedBYFinace.length;
        this.totalExpensePendingByfinance = pendingBYFinace.length;


      }


      this.currentApprovedData = this.totalExpenseApprovedByfinance
      this.currentPendingData = this.totalExpensePendingByfinance

      // -----------------------------------------FINAL DATA----------------------------------------------------------------------

      const reimbursementCounts = this.arrExpenseTypeRaised.reduce((acc: any, item: any) => {
        acc[item.reimbursementType] = (acc[item.reimbursementType] || 0) + 1;
        return acc;
      }, {});


      const result = Object.entries(reimbursementCounts).map(([type, count]) => ({
        reimbursementType: type,
        count: count,
      }));


      this.reimbursementTypeCount = result;
      this.getReimbursementCount(result, 'bar', this.selectedYearForDashboard, '', '');
      // if(this.loggedInUserRole=='Employee'){

      // setTimeout(() => {
      // this.getApprovedPaidAmountByCount('bar', this.selectedYearForDashboard, '', '');

      // }, 500)
      // }
      this.getReimbursementYearlyByCount('bar');
      this.processAllGraphDateRange();
    });
  }

  removeDuplicateEmployeeIds(data: any[]) {
    const seen = new Set();
    return data.filter((item) => {
      if (seen.has(item.employeeId)) {
        return false;
      }
      seen.add(item.employeeId);
      return true;
    });
  }

  // getpmsyearlist() {
  //   this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
  //     this.pmsYears = [];

  //     data?.data?.yearRanges?.forEach((ele: any) => {
  //       var test = ele.split('_');
  //       let obj = {
  //         year: test[0] + '-' + test[1]
  //       };

  //       // Get current year
  //       const currentYear = new Date().getFullYear();

  //       // Ensure only past and current years are included
  //       var yearParts = obj.year.split('-');
  //       let fromYear = parseInt(yearParts[0]);
  //       let toYear = parseInt(yearParts[1]);

  //       // Add to pmsYears only if it's not a future year
  //       if (toYear <= currentYear) {
  //         this.pmsYears.push(obj);
  //       }
  //     });

  //     this.pmsYears?.forEach((ele: any) => {
  //       const currentYear = new Date().getFullYear();
  //       let yearValue = '';

  //        if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
  //         yearValue = `${currentYear}-${currentYear}`; // Calendar year
  //       } else if (this.loggedInCompanyFiscalyear === 'Apr_Mar') {
  //         if (new Date().getMonth() < 3) {
  //           // If it's Jan, Feb, or Mar, we're in the previous fiscal year
  //           yearValue = `${currentYear - 1}-${currentYear}`;
  //         } else {
  //           // From Apr onwards, it's the current fiscal year
  //           yearValue = `${currentYear}-${currentYear + 1}`;
  //         }
  //       }

  //       if (ele?.year == yearValue) {
  //         this.selectedYearForReimbursement = ele?.year;
  //         this.selectedYearForDashboard = ele?.year;
  //         this.currentYearSelected = ele?.year;

  //         // this.viewDashboardExpenseByYear(this.selectedYearForDashboard);


  //         var test = ele?.year?.split('-');
  //         this.fromYear = test[0];
  //         this.toYear = test[1];
  //       }
  //     });

  //     this.getEmployee();
  //   });

  // }




    getpmsyearlist() {
      this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
        this.pmsYears = formatYearRanges(data?.data?.yearRanges);
  
        const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);
  
        const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;
        
        this.setSelectedYear(yearValue);
        this.getEmployee();

      });
    }
    setSelectedYear(yearValue: string): void {
      const selectedYearObj = this.pmsYears.find((ele:any) => ele.year === yearValue);
      if (selectedYearObj) {
            // this.selectedYearForCompetency = selectedYearObj?.year;
            this.selectedYearForReimbursement = selectedYearObj?.year;
            this.selectedYearForDashboard = selectedYearObj?.year;
            this.currentYearSelected = selectedYearObj?.year;
  
            let test = selectedYearObj?.year.split('-');
            this.fromYear = test[0];
            this.toYear = test[1];
      }
    }


  // Date Range
  taskFromDateForThirdGraph: any;
  taskToDateForThirdGraph: any;


  formatDateToISO(date: Date): string {
    const pad = (num: number): string => String(num).padStart(2, '0');
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1); // Months are zero-based
    const day = pad(date.getDate());

    return `${year}-${month}-${day}`;
  }

  processFirstGraphDateRange(): void {



    if (this.taskFromDate && this.taskToDate) {
      const fromDate = new Date(this.taskFromDate);
      const toDate = new Date(this.taskToDate);

      fromDate.setHours(0, 0, 0, 0);  // Start of the day
      toDate.setHours(23, 59, 59, 999); // End of the day

      const formattedFromDate = this.formatDateToISO(fromDate) + "T00:00:00";
      const formattedToDate = this.formatDateToISO(toDate) + "T23:59:59";

      this.selectedFromDated = formattedFromDate;
      this.selectedtoDated = formattedToDate;
      
      this.selectFromDate = formattedFromDate;
      this.selectToDate = formattedToDate;

      console.error(  this.selectFromDate+" "+  this.selectToDate);
      
      this.getReimbursementCount(
        this.reimbursementTypeCount,
        this.selectGraphType,
        this.selectedYearForReimbursement,
        formattedFromDate,
        formattedToDate
      );
    } else {
      console.log('No filtering applied for Graph 1, returning all data');
    }
  }
  processThirdGraphDateRange(): void {
    if (this.taskFromDateForThirdGraph && this.taskToDateForThirdGraph) {
      const fromDateThird = new Date(this.taskFromDateForThirdGraph);
      const toDateThird = new Date(this.taskToDateForThirdGraph);

      fromDateThird.setHours(0, 0, 0, 0);  // Start of the day
      toDateThird.setHours(23, 59, 59, 999); // End of the day

      const formattedFromDateThirdGraph = this.formatDateToISO(fromDateThird) + "T00:00:00";
      const formattedToDateThirdGraph = this.formatDateToISO(toDateThird) + "T23:59:59";

      this.selectedFromDated = formattedFromDateThirdGraph;
      this.selectedtoDated = formattedToDateThirdGraph;

      this.selectFromDateThird  = formattedFromDateThirdGraph;
      this.selectToDateThird  = formattedToDateThirdGraph;

      this.getApprovedPaidAmountByCount(
        this.selectGraphThreeType,
        this.selectedYearForDashboard,
        formattedFromDateThirdGraph,
        formattedToDateThirdGraph
      );
    } else {
      console.log('No filtering applied for Graph 3, returning all data');
    }
  }
  taskToDateForAllGraph: any;
  taskFromDateForAllGraph: any
  
  processAllGraphDateRange() {

    this.taskFromDate = this.taskFromDateForAllGraph;
    this.taskToDate = this.taskToDateForAllGraph;
    this.taskFromDateForThirdGraph = this.taskFromDateForAllGraph;
    this.taskToDateForThirdGraph = this.taskToDateForAllGraph;
    this.onDateChangeDashboard();
    this.processThirdGraphDateRange();
    this.processFirstGraphDateRange();


  }


  isReimbursementTypeIcon: any = 'bar';
  isApprovedByFinanceIcon: any = 'bar';
  isFinanceAmountPaidIcon: any = 'bar';
  isApprovedByPaidAmountIcon: any = 'bar';
  isReimbursementTypeTable: any = false;
  isApprovedByFinanceTable: any = false;
  isApprovedByPaidAmountTable: any = false;

  // Reimbursement Type Year
  // For Year Select

  viewReimbursementYear(year: any) {
    this.taskFromDate = null;
    this.taskToDate = null;
    this.getReimbursementCount(this.reimbursementTypeCount, 'bar', year, '', '');
  }
  selectedTypeTabIndex: any = 1;
  selectedTypeTabName: any = 'Finance'
  tabTypeChanged(event: any) {

  }

  // Dashboard Year
  viewDashboardExpenseByYear(year: any) {
    console.warn("inside viewDashboardExpenseByYear " + year);
    this.selectedYearForDashboard = year;
    this.selectedYearForReimbursement = year;
    this.currentYearSelected = year
    this.dashBoardreimbursmentData();
    this.selectGraphType = this.selectGraphType ? this.selectGraphType : 'bar';
    this.getReimbursementCount(this.reimbursementTypeCount, this.selectGraphType, this.selectedYearForDashboard, '', '');
    this.getApprovedPaidAmountByCount(this.selectGraphType, this.selectedYearForDashboard, this.taskFromDateForAllGraph,  this.taskToDateForAllGraph);

  }

  // Start Graph :  One
  switchReimbursementTypeGraph(graphType: any) {
    this.selectGraphType = graphType;
    this.isReimbursementTypeIcon = graphType;
    this.isReimbursementTypeTable = false;
    console.error()
    
     
    console.log(this.selectFromDate)
    this.selectedYearForReimbursement = this.currentYearSelected;
    if (graphType == 'bar') {
      this.getReimbursementCount(this.reimbursementTypeCount, 'bar', this.selectedYearForDashboard, this.selectFromDate, this.selectToDate);
    }
    if (graphType == 'line') {
      // this.reimbursementCountLineGraph();
      this.getReimbursementCount(this.reimbursementTypeCount, 'line', this.selectedYearForDashboard, this.selectFromDate, this.selectToDate);
    }

  }
  switchReimbursementTypeTable() {
    this.selectGraphType = 'table';
    this.isReimbursementTypeIcon = '';
    this.isReimbursementTypeTable = true;
/*     this.taskFromDate = null;
    this.taskToDate = null; */
    this.selectedYearForReimbursement = this.currentYearSelected;
    this.getReimbursementCount(this.reimbursementTypeCount, '', this.currentYearSelected,  this.selectFromDate, this.selectToDate);

  }
  // End Graph :  One

  // Start Graph :  Two
  switchApprovedByFinanceGraph(graphType: any) {
    this.selectGraphTwoType = graphType;
    this.isApprovedByFinanceIcon = graphType;
    this.isApprovedByFinanceTable = false;
    if (graphType == 'bar') {
      this.getReimbursementYearlyByCount('bar');
    }
    if (graphType == 'line') {
      this.getReimbursementYearlyByCount('line');
    }

  }

  switchApprovedByFinanceTable() {
    this.selectGraphTwoType = 'table';
    this.isApprovedByFinanceIcon = '';
    this.isApprovedByFinanceTable = true;
    this.taskFromDate = null;
    this.taskToDate = null;
    this.selectedYearForReimbursement = this.currentYearSelected;
    // this.getReimbursementCount(this.reimbursementTypeCount, '', this.currentYearSelected, '', '');

  }
  // End Graph :  Two
  // Start Graph :  Three

  isFinanceAmountPaidTable: boolean = false;
  switchFinanceAmountPaidGraph(graphType: any) {
    console.warn("inside switchFinanceAmountPaidGraph");
    this.selectGraphThreeType = graphType;
    this.isFinanceAmountPaidIcon = graphType;
    this.isFinanceAmountPaidTable = false;
    if (graphType == 'bar') {
      this.getApprovedPaidAmountByCount('bar', this.selectedYearForDashboard,  this.selectFromDateThird, this.selectToDateThird);
    }
    if (graphType == 'line') {
      this.getApprovedPaidAmountByCount('line', this.selectedYearForDashboard,this.selectFromDateThird, this.selectToDateThird);
    }

  }
  switchFinanceAmountPaidTable() {
    this.selectGraphThreeType = 'table';
    this.isFinanceAmountPaidIcon = '';
    this.isFinanceAmountPaidTable = true;
/*     this.taskFromDate = null;
    this.taskToDate = null; */
    this.selectedYearForReimbursement = this.currentYearSelected;
    // this.getReimbursementCount(this.reimbursementTypeCount, '', this.currentYearSelected, '', '');

  }

  onDateChangeDashboard(): void {
    console.log("onDateChangeDashboard");

    if (this.taskFromDateForAllGraph && this.taskToDateForAllGraph) {
      const fromDate = new Date(this.taskFromDateForAllGraph);
      const toDate = new Date(this.taskToDateForAllGraph);

      fromDate.setHours(0, 0, 0, 0);  // Start of the day in local time
      toDate.setHours(23, 59, 59, 999); // End of the day in local time

      const toISOWithUTCOffset = (date: Date): string => {
        const pad = (num: number): string => String(num).padStart(2, '0');
        const year = date.getFullYear();
        const month = pad(date.getMonth() + 1);
        const day = pad(date.getDate());

        return `${year}-${month}-${day}T00:00:00.000+00:00`;
      };

      const formattedFromDate = toISOWithUTCOffset(fromDate);
      const formattedToDate = toISOWithUTCOffset(toDate);

      this.selectFromDate = formattedFromDate;
      this.selectToDate = formattedToDate;

      
      // Check if totalExpenseRaisedCount is an array before using filter

      const filteredData = this.arrExpenseTypeRaised.filter((item: any) => {
        const itemDate = new Date(item.date);
        return (
          itemDate >= new Date(formattedFromDate) &&
          itemDate <= new Date(formattedToDate)
        );
      });

      this.totalExpenseRaisedCount = filteredData.length;

      if (filteredData.length <= 0) {
        this.totalExpenseApprovedByfinance = 0;
        this.totalExpensePendingByfinance = 0;
        this.pendingWithManager = 0;

      }

    }
    else {
      this.totalExpenseRaisedCount = this.arrExpenseTypeRaised.length
      this.totalExpenseApprovedByfinance = this.currentApprovedData;
      this.totalExpensePendingByfinance = this.currentPendingData;
      this.pendingWithManager = this.currentPendingWithManager;
    }
  }



  // Start For Graph One
  getReimbursementCount(result: { reimbursementType: string; count: unknown; }[], graphType: string, year: any, fromDate: any, toDate: any) {



    let intUserId = (this.loggedInUserRole == 'Employee' || (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'MD')) ? this.loggdinUserIDBydefault : 0

    const request = {
      "startDate": fromDate,
      "endDate": toDate,
      "employeeId": intUserId,
      "companyId": this.loggedInUserCompanyID,
      "year": year
    };



    if (this.loggedInUserRole == 'Employee' || (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'MD')) {

      if ((this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'MD') && sessionStorage.getItem('financeAdminId') == this.loggedInUserId) {

        var reimbursementApplications = this.config.HrReimbursementCountSummary;
      } else {
        if (this.OnlyFinance) {
          var reimbursementApplications = this.config.HrReimbursementCountSummary;
        } else {
          var reimbursementApplications = this.config.EmployeeReimbursementCountSummary;

        }
      }
    } else {
      var reimbursementApplications = this.config.HrReimbursementCountSummary;
    }


    this.httpService.callPostService(reimbursementApplications, request).subscribe((response: any) => {
      let reimbursementAcive = response.data;

      if (reimbursementAcive) {
        let reimbursementData = result;
        let mergedData = reimbursementAcive.map((active: { reimbursementType: string; }) => {
          const matchedData = reimbursementData.find(
            data => data.reimbursementType === active.reimbursementType
          );
          return {
            reimbursementType: active.reimbursementType,
            count: matchedData ? matchedData.count : 0
          };
        });


        this.reimbursementTypeTable = mergedData;
        

        let transformedData = mergedData.map((item: any) => ({
          xAxisValueData: item.reimbursementType,
          seriesValueOneData: item.count
        }));

        transformedData.xAxisName = 'Reimbursement Type';
        transformedData.yAxisName = 'Reimbursement Count';
        transformedData.seriesLabelOne = 'Count';
        transformedData.seriesLabelTwo = '';
        if (graphType == 'bar') {
          this.reimbursementBarChartActive(transformedData, 'bar-line-chart', 'single');
        }
        if (graphType == 'line') {
          this.reimbursementCountLineGraph(transformedData, 'bar-line-chart', 'single');
        }

      } else {
        console.log("transformedData1")

        var transformedData1: any = [];

        if (graphType == 'bar') {
          this.reimbursementBarChartActive(transformedData1, 'bar-line-chart', 'single');
        }
        if (graphType == 'line') {
          this.reimbursementCountLineGraph(transformedData1, 'bar-line-chart', 'single');
        }

      }

    });
  }
  // End For Graph One

  // Start For Graph Two
  arrApprovedByFinanceTable: any = [];
  getReimbursementYearlyByCount(graphType: string) {
    // let intUserId = (this.selectUserId != undefined) ? this.selectUserId : this.loggedInUserId;
    let intUserId = this.loggdinUserIDBydefault;

    let request;

    if (sessionStorage.getItem('financeAdminId') == this.loggedInUserId) {
      request = {

        "companyId": this.loggedInUserCompanyID,
        "financeId": this.loggedInUserId
      }
    } else {
      if (this.loggedInUserRole == 'Employee' || (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'MD')) {

        if (((this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'MD') || this.loggedInUserRole == 'Employee') && sessionStorage.getItem('financeAdminId') == this.loggedInUserId) {
          if (this.httpService.passApprovematrixForReport == 'EMPLOYEE_TO_FINANCE') {
            if ((sessionStorage.getItem('financeAdminId') == this.loggedInUserId) && this.loggedInUserRole == 'Employee') {
              request = {
                "companyId": this.loggedInUserCompanyID,
                "employeeId": intUserId
              };
            } else {

              request = {
                "companyId": this.loggedInUserCompanyID,
              };
            }
          } else {

            request = {
              "companyId": this.loggedInUserCompanyID,
              "employeeId": intUserId
            };

          }
        } else {

          request = {
            "companyId": this.loggedInUserCompanyID,
            "employeeId": intUserId
          };

        }

      } else {
        request = {
          "companyId": this.loggedInUserCompanyID,
        };

      }
    }

    this.httpService.callPostService(`${this.config.yearlyReimbursementCountSummary}`, request).subscribe((response: any) => {
      if (response.data.length > 0) {
        let reimbursementAcive = response.data;

        this.arrApprovedByFinanceTable = reimbursementAcive;



        // Transforming data with new property names
        const transformedData = reimbursementAcive.map((item: any) => ({
          xAxisValueData: item.year,
          seriesValueOneData: item.totalAmount,
          seriesValueTwoData: item.employeeCount,
        }));
 
        transformedData.xAxisName = 'Reimbursement Type';
        transformedData.yAxisName = 'Reimbursement Count';
        transformedData.seriesLabelOne = 'Total Amount';
        transformedData.seriesLabelTwo = 'Employee Count';

        if (graphType == 'bar') {
          this.reimbursementBarChartActive1(transformedData, 'bar-line-approvedByFinance-chart', 'double');
        }
        if (graphType == 'line') {
          this.reimbursementCountLineGraph(transformedData, 'bar-line-approvedByFinance-chart', 'double');
        }
      } else {
        console.log("Data Not Found : getReimbursementYearlyByCount")
      }


    });
   
    // this.getApprovedPaidAmountByCount('bar', this.selectedYearForDashboard, this.taskFromDateForAllGraph,  this.taskToDateForAllGraph);
  }
  // End For Graph Two

  // Start For Graph Three
  arrApprovedPaidAmountTable: any = [];
  // getReimbursementCount(result: { reimbursementType: string; count: unknown; }[], graphType: string, year: any, fromDate: any, toDate: any) {
  getApprovedPaidAmountByCount(graphType: string, year: any, fromDate: any, toDate: any) {
    let intUserId;
    if (this.httpService.passApprovematrixForReport == 'EMPLOYEE_TO_FINANCE') {

      intUserId = ((this.loggedInUserRole == 'Employee') && (sessionStorage.getItem('financeAdminId') == this.loggedInUserId)) ? (this.loggdinUserIDBydefault) :
        ((this.loggedInUserRole == 'Employee') && (sessionStorage.getItem('financeAdminId') != this.loggedInUserId)) ? (this.loggdinUserIDBydefault) :
          (((this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'MD')) && (sessionStorage.getItem('financeAdminId') == this.loggedInUserId)) ? '' :
            (((this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'MD')) && (sessionStorage.getItem('financeAdminId') != this.loggedInUserId)) ? this.loggdinUserIDBydefault : '';
    }
    else {

      intUserId = (((this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'MD') || this.loggedInUserRole == 'Employee') && sessionStorage.getItem('financeAdminId') != this.loggedInUserId) ? (this.loggdinUserIDBydefault) : ((this.loggedInUserRole == 'Employee') && (sessionStorage.getItem('financeAdminId') == this.loggedInUserId)) ? (this.loggdinUserIDBydefault) : (((this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'MD')) && (sessionStorage.getItem('financeAdminId') == this.loggedInUserId)) ? this.loggdinUserIDBydefault : '';
    }
    let request;
    if (sessionStorage.getItem('financeAdminId') == this.loggedInUserId) {

      request = {
        "startDate": fromDate,
        "endDate": toDate,
        "companyId": this.loggedInUserCompanyID,
        "year": year,
        "employeeId": null,
        "financeId": this.loggedInUserId
      };
    } else {
      if (this.loggedInUserRole === 'HR Admin') {
        request = {
          "startDate": fromDate,
          "endDate": toDate,
          "companyId": this.loggedInUserCompanyID,
          "year": year,
          "employeeId": ''
        };

      } else {
        request = {
          "startDate": fromDate,
          "endDate": toDate,
          "companyId": this.loggedInUserCompanyID,
          "year": year,
          "employeeId": this.loggdinUserIDBydefault
        };

      }
    }
  
    this.httpService.callPostService(`${this.config.ReimbursementApplicationCountSummary}`, request).subscribe((response: any) => {


      let reimbursementAcive = response.data;

      this.arrApprovedPaidAmountTable = reimbursementAcive;

      // Transforming data with new property names
      const transformedData = reimbursementAcive.map((item: any) => ({
        xAxisValueData: item.reimbursementType,
        seriesValueOneData: item.totalActualAmount,
        seriesValueTwoData: item.totalAssignedAmount,
      }));


      transformedData.xAxisName = 'Reimbursement Type';
      transformedData.yAxisName = 'Reimbursement Count';
      transformedData.seriesLabelOne = 'Total Actual Amount';
      transformedData.seriesLabelTwo = 'Total Assigned Amount';

      if (graphType == 'bar') {
        this.reimbursementBarChartActive(transformedData, 'bar-line-amount-chart', 'double');
      }
      if (graphType == 'line') {
        this.reimbursementCountLineGraph(transformedData, 'bar-line-amount-chart', 'double');
      }



    });
  }


  private myChart!: echarts.ECharts;

  // Usage for Line Chart
  reimbursementCountLineGraph(data: any, idSelector: any, graphType: any): void {
    createChart(idSelector, 'line', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
  }

  // Usage for Bar Chart
  reimbursementBarChartActive(data: any, idSelector: any, graphType: any): void {


    createChart(idSelector, 'bar', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
  }

  reimbursementBarChartActive1(data: any, idSelector: any, graphType: any): void {


    createChart(idSelector, 'bar', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
  }

  downloadChartAsPDF(type: any): void {


    const currentDate = new Date();
    const todayDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
      .toString()
      .padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;
    const formattedFromDate = (this.selectedFromDated == undefined) ? '' : formatDate(this.selectedFromDated);
    const formattedtoDate = (this.selectedtoDated == undefined) ? '' : formatDate(this.selectedtoDated);

    if (type == 'Total Expense Amount') {
      var idSelector = (this.selectGraphTwoType == 'table') ? 'table-approvedByFinance-data' : 'bar-line-approvedByFinance-chart';

    } else if (type == 'Expense Paid VS Applied') {
      var idSelector = (this.selectGraphTwoType == 'table') ? 'table-data-Finance-Employee' : 'bar-line-amount-chart';
    } else {
      var idSelector = (this.selectGraphType == 'table') ? 'table-data' : 'bar-line-chart';

    }
    
    let selectedYearForReimbursement;
    if(this.loggedInCompanyFiscalyear == "Jan_Dec"){
      let selectedYear = this.selectedYearForReimbursement;
      let year = selectedYear.split("-")[0];
       selectedYearForReimbursement =  year;
      }else{
        selectedYearForReimbursement =  this.selectedYearForReimbursement;

    }
    // Call the common function from the service
    this.PdfDownload.downloadPDF(
      idSelector, // chartId
      type, // Title
      selectedYearForReimbursement, // Year
      formattedFromDate, // From Date
      formattedtoDate,
    );
  }


  //--------------------------------------------------Count Api-------------------------------------------------

  onClickCard(event: any) {
 
    if (event == 1 && this.totalExpenseRaisedCount.length == 0) {
      return;
    }
    if (event == 3 && this.totalExpenseApprovedByfinance.length == 0) {
      return;
    } 
    if (event == 4 && (this.totalExpensePendingByfinance.length == 0 || this.totalExpensePendingByfinance == 0)) {
      return;
    }
 
    if (event =="Manager" && this.pendingWithManager == 0) {
      return;
    }

 
    const dialogConfig = new MatDialogConfig();

    dialogConfig.height = '70%';
    dialogConfig.width = '100%';
    dialogConfig.data = {
      btn2: 'OK',
      moduleName: event,
      loggdingUserId: this.userId,
      userID: this.loggdinUserIDBydefault,
      btn2BgColor: this.buttonColorName,
      arrEmployeeDetiails: this.arrEmployeeDetiails,
      showSuccessIcon: true,
      showSuccessMessage: false,
      showCloseIcon: false
    };
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(ExpenseDashboardDetailsComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
    });

  }
  selectedEmployee: any = []
  onEmployeeChangeByManager(event: any) {
    console.warn("inside asset change");
    this.forEmployeDDlogginUserID = event;
    this.loggdinUserIDBydefault = event;
    this.selectUserId = event;
    this.dashBoardreimbursmentData()
    this.getReimbursementCount(this.reimbursementTypeCount, 'bar', this.selectedYearForDashboard, '', '');
    this.getApprovedPaidAmountByCount('bar', this.selectedYearForDashboard, '', '');
  };


  ngOnDestroy(): void {
    // Remove resize listener
    // window.removeEventListener('resize', this.onResize.bind(this));
  }

}
